import React, { FC, ReactElement } from 'react'
import styled from 'styled-components'
import Comment from 'components/Comment'

const Indicator: FC<{
  darkModeOn?: string
  mainTitle: string
  subTitle: string
  classRain: string
  valueToday: string
  classUnit: string
  unitSection: string
  value2060: string
  displayNonePercent: string
  percent2060: string
  valueClimate2060: string
  classSmall: string
  value2085: string
  percent2085: string
  valueClimate2085: string
  textIndicator: string
  commentIndicator: string
  index: string
}> = ({
  darkModeOn,
  mainTitle,
  subTitle,
  classRain,
  valueToday,
  classUnit,
  unitSection,
  value2060,
  displayNonePercent,
  percent2060,
  valueClimate2060,
  classSmall,
  value2085,
  percent2085,
  valueClimate2085,
  textIndicator,
  commentIndicator,
  index,
}): ReactElement => {
  return (
    <IndicatorContainer>
      <div
        className='ui two centered column grid stackable'
        id={'indicator-' + index}
      >
        <div className='row introTitle'>
          {/* <div className='one wide column mobile hidden' /> */}
          <div className='ui column titleColumn'>
            <div className='titleContainer'>
              <h3 dangerouslySetInnerHTML={{ __html: mainTitle }} />
            </div>

            <div
              className='subtitleContainer'
              dangerouslySetInnerHTML={{ __html: subTitle }}
            />
          </div>
        </div>

        <div className='fifteen wide column'>
          <div className='ui equal width grid'>
            <div className={`column tight today ${classRain}`}>
              <div className='boxContainer'>
                <div className='boxContent'>
                  <p className='boxPeriod'>
                    <span className={`boxStyleToday ${classRain}`}>Heute</span>
                  </p>
                  <p
                    className='boxPeriodDetail'
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    (Ø 1991–2020)
                  </p>
                  <div className='boxCelsius'>
                    <h4>{valueToday}</h4>
                    <p className={`${classUnit}`}>{unitSection}</p>
                  </div>
                </div>
              </div>
              <div className='arrowBox'>
                <div className={`arrow-down ${classRain}`} />
              </div>
            </div>

            <div className={`column tight c2060 shadow ${classRain}`}>
              <div className='boxContainer'>
                <div className='boxContent'>
                  <p className='boxPeriod'>
                    <span className={`boxStyle2060 ${classRain}`}>2060</span>
                  </p>
                  <p
                    className='boxPeriodDetail'
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    (Ø 2045–2074)
                  </p>
                  <div className='boxCelsius'>
                    <h4>{value2060}</h4>
                    <p className={`${classUnit}`}>{unitSection}</p>
                  </div>
                  <div className={`boxProzent ${displayNonePercent}`}>
                    <p className='prozent'>({percent2060})</p>
                  </div>
                  <div className='divider' />
                  <div className='boxClimate'>
                    <div className='iconWrapper mobile hidden'>
                      <span className='climateNr bold'>{valueClimate2060}</span>
                      <span className={`climateNr bold ${classSmall}`}>
                        {unitSection}
                      </span>
                    </div>

                    <div className='iconWrapper mobile only'>
                      <span className='climateNr bold'>{valueClimate2060}</span>
                      <span className={`climateNr bold ${classSmall}`}>
                        {unitSection}
                      </span>
                    </div>

                    <p className='boxClimateDetail'>
                      mit verstärktem Klimaschutz
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className={`column tight c2085 ${classRain}`}>
              <div className='boxContainer'>
                <div className='boxContent'>
                  <p className='boxPeriod'>
                    <span className={`boxStyle2085 ${classRain}`}>2085</span>
                  </p>
                  <p
                    className='boxPeriodDetail'
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    (Ø 2070–2099)
                  </p>
                  <div className='boxCelsius'>
                    <h4>{value2085}</h4>
                    <p className={`${classUnit}`}>{unitSection}</p>
                  </div>

                  <div className={`boxProzent ${displayNonePercent}`}>
                    <p className='prozent'>({percent2085})</p>
                  </div>

                  <div className='divider' />
                  <div className='boxClimate'>
                    <div className='iconWrapper mobile hidden'>
                      <span className='climateNr bold'>{valueClimate2085}</span>
                      <span className={`climateNr bold ${classSmall}`}>
                        {unitSection}
                      </span>
                    </div>

                    <div className='iconWrapper mobile only'>
                      <span className='climateNr bold'>{valueClimate2085}</span>
                      <span className={`climateNr bold ${classSmall}`}>
                        {unitSection}
                      </span>
                    </div>

                    <p className='boxClimateDetail'>
                      mit verstärktem Klimaschutz
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='row stackable'>
          {/* <div className='one wide column mobile hidden' /> */}
          <div
            className='five wide column tight textWrapper'
            style={{ padding: '0 !important' }}
          >
            <div className='textContainer '>
              <span
                className={`${classRain}`}
                dangerouslySetInnerHTML={{ __html: textIndicator }}
              />
            </div>
          </div>
          <div className='ten wide column' style={{ border: 'mportant' }}>
            <Comment
              avatarSrc={require('./andreas-fischer.jpg')}
              name='Andreas Fischer'
              byLine='Meteo Schweiz'
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: commentIndicator,
                }}
              ></div>
            </Comment>
          </div>
        </div>
      </div>
    </IndicatorContainer>
  )
}
const IndicatorContainer = styled.div`
  font-family: var(--font-sans-serif);
  margin-top: 6em;
  @media screen and (min-width: 600px) {
    margin-top: 8em !important;
  }

  h3 {
    text-align: center;
    font-size: 2.4em !important;
    line-height: 1.2em;
    @media screen and (min-width: 600px) {
      font-size: 3em !important;
    }
    margin-bottom: 0.2em;
    font-weight: 800;
    font-family: var(--font-sans-serif);
    color: var(--text-color);
  }

  h3:before {
    display: block;
    order: -2;
    width: 6rem;
    margin: 0 auto 4rem;
    border-bottom: 2px solid var(--divider-gray);
    content: '';
  }

  #indicator-0 h3:before {
    border-bottom: none;
    margin-bottom: 0.2em;
  }

  h4 {
    font-size: 2.6em !important;
    @media screen and (min-width: 600px) {
      font-size: 4.4em !important;
    }
    @media screen and (max-width: 320px) {
      font-size: 2.2em !important;
    }
    font-weight: 800;
    font-family: var(--font-sans-serif);
  }

  .subtitleContainer {
    text-align: center;
    font-size: 1.5em !important;
    line-height: 1.5em;
    max-width: 440px;
    margin: 0 auto;
    font-family: var(--font-sans-serif) !important;
    margin-bottom: 0.4em;
    @media screen and (min-width: 600px) {
      font-size: 1.8em !important;
      margin-bottom: 0.8em;
    }
    color: var(--text-color);
  }

  span.bold {
    font-weight: 800;
  }

  .tight {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
  }

  .column.today {
    background: #fff3df;
    z-index: 1;
    color: #f90;
  }

  .column.today.rain {
    z-index: 1;
    color: #0b7ace;
    background: #e1f2ff;
  }

  .column.c2060 {
    background: #fbe9e7;
    z-index: 2;
    color: #ff5607;
  }

  .column.c2060.rain {
    z-index: 1;
    color: #009788;
    background: #dff2f1;
  }

  .column.c2085 {
    background: #fde4ec;
    color: #ec1561;
  }

  .column.c2085.rain {
    color: #9b8557;
    background: #f5f2e8;
  }

  .shadow {
    -webkit-box-shadow: 30px 0px 30px -30px rgba(0, 0, 0, 0.2),
      -30px 0px 30px -30px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 30px 0px 30px -30px rgba(0, 0, 0, 0.2),
      -30px 0px 30px -30px rgba(0, 0, 0, 0.2);
    box-shadow: 30px 0px 30px -30px rgba(0, 0, 0, 0.2),
      -30px 0px 30px -30px rgba(0, 0, 0, 0.2);

    @media only screen and (max-width: 599px) {
      -webkit-box-shadow: 0px 0px 20px -20px rgba(0, 0, 0, 0.2),
        -0px 0px 20px -20px rgba(0, 0, 0, 0.2);
      -moz-box-shadow: 0px 0px 20px -20px rgba(0, 0, 0, 0.2),
        -20px 0px 20px -20px rgba(0, 0, 0, 0.2);
      box-shadow: 20px 0px 20px -20px rgba(0, 0, 0, 0.2),
        -20px 0px 20px -20px rgba(0, 0, 0, 0.2);
    }
  }

  .bold {
    font-weight: 700;
  }

  @media only screen and (max-width: 599px) {
    .ui.grid > .stackable.stackable.row > .column.textWrapper,
    .ui.stackable.grid > .row > .column.textWrapper,
    .ui.stackable.grid > .wide.column.textWrapper {
      padding: 0 !important;
    }

    .ui.stackable.grid > .row > .ten.wide.column {
      padding: 0 !important;
      margin-top: 2em !important;
    }
  }
  .textContainer {
    color: #f90;
    span.rain {
      color: #0b7ace;
    }
    margin-top: 0.4em;
    @media screen and (max-width: 599px) {
      margin-top: 0.7em;
    }
    font-family: var(--font-sans-serif);
    font-size: 1.5em !important;
    line-height: 1.5em;
  }

  .boxContainer {
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  .boxContentIntro {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    // height: 100%;
    margin-bottom: 1em;
    font-family: var(--font-sans-serif);
    color: #353535;
    border-top: 1px dotted #353535;
    @media screen and (max-width: 599px) {
      border: none;
    }

    h5 {
      margin: 0;
      text-align: center;
      font-family: var(--font-sans-serif);
    }
    h2 {
      // position: absolute;
      align-self: flex-start;
      @media screen and (max-width: 599px) {
        align-self: center;
        text-align: center;
      }
      font-family: var(--font-sans-serif);
      font-weight: 800;
      margin: 0;
      top: 0;
      left: 0;
      padding-top: 0.5em;
      font-size: 1.4em;
    }

    p {
      align-self: flex-start;
      padding-top: 0.4em;
      @media screen and (max-width: 599px) {
        align-self: center;
        text-align: center;
      }
    }
  }

  .boxContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: var(--font-sans-serif);
    padding-bottom: 3em;
    padding-top: 3em;
    padding-right: 0.2em;
    padding-left: 0.2em;
    @media screen and (max-width: 599px) {
      padding-bottom: 1.5em;
      padding-top: 1.5em;
    }
    @media screen and (max-width: 375px) {
      padding-bottom: 0.7em;
      padding-top: 0.7em;
    }
    @media screen and (max-width: 320px) {
      padding-bottom: 0.55em;
      padding-top: 0.55em;
    }

    p.boxPeriod {
      // font-size: 1.3em;
      margin: 0;
      text-align: center;
      padding-bottom: 0.2em;
    }

    p.boxPeriodDetail {
      font-family: var(--font-sans-serif);
      font-size: 1.4em;
      font-weight: 400;
      letter-spacing: -0.01em;
      margin-bottom: 1em;
      text-align: center;
      @media screen and (max-width: 599px) {
        font-size: 1.15em;
        margin-bottom: 0.6em;
      }
    }

    h5 {
      margin: 0;
      text-align: center;
      font-family: var(--font-sans-serif);
    }

    .boxCelsius {
      display: flex;
      align-items: baseline;
      text-align: center;
      flex-wrap: nowrap;
      justify-content: center;

      h2 {
        text-align: center;
        font-family: var(--font-sans-serif);
        font-weight: 800;
        margin: 0;
        font-size: 2.6em;
        @media screen and (max-width: 1024px) {
          font-size: 2.3em;
        }
        @media screen and (max-width: 599px) {
          font-size: 1.6em;
        }
        @media screen and (max-width: 375px) {
          font-size: 1.45em;
        }
        @media screen and (max-width: 320px) {
          font-size: 1.4em;
        }
      }

      p.celsius {
        font-family: var(--font-sans-serif);
        font-size: 2em !important;
        font-weight: 800;
        padding-left: 0.3em;
      }

      p.milimeter {
        font-family: var(--font-sans-serif);
        font-size: 2em !important;
        font-weight: 800;
        padding-left: 0.3em;

        @media screen and (max-width: 599px) {
          font-size: 1.2em !important;
        }
        @media screen and (max-width: 375px) {
          font-size: 1em !important;
          padding-left: 0.2em;
        }
      }
    }

    span.small {
      @media screen and (max-width: 599px) {
        font-size: 0.8em;
      }
      @media screen and (max-width: 375px) {
        font-size: 0.6em;
      }
    }

    span.mm {
      @media screen and (max-width: 599px) {
        font-size: 0.8em;
      }
      @media screen and (max-width: 375px) {
        font-size: 0.6em;
      }
    }

    .climateNr {
      font-size: 2em;
      padding-right: 0.2em;
      @media screen and (max-width: 375px) {
        font-size: 1.6em;
      }
    }

    .boxProzent {
      p.prozent {
        font-family: var(--font-sans-serif);
        font-weight: 400;
        @media screen and (max-width: 599px) {
          font-size: 1.2em !important;
        }
      }
    }

    .boxProzent.none {
      display: none;
    }

    h2 {
      text-align: center;
      font-family: var(--font-sans-serif);
      font-weight: 800;
      margin: 0;
      font-size: 2.4em;
      @media screen and (max-width: 599px) {
        font-size: 1.5em;
      }

      span.celsius {
        font-size: 1em !important;
      }
    }

    .boxClimate {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 1em;
      @media screen and (max-width: 599px) {
        padding-top: 0.5em;
      }
    }

    p.boxClimateDetail {
      font-family: var(--font-sans-serif);
      font-size: 1.6em;
      font-weight: 400;
      line-height: 1.1em;
      text-align: center !important;
      @media screen and (max-width: 599px) {
        font-size: 1.2em;
        margin-top: 0.2em;
      }
      @media screen and (max-width: 320px) {
        font-size: 1em;
      }
    }
  }

  .climateInfo {
    display: flex;
    justify-content: center;
    font-family: var(--font-sans-serif);
    font-weight: 200;
    margin-bottom: 2em;
  }

  i.leaf.icon.small {
    margin: 0 0.2rem 0 0;
    font-size: 0.65em !important;
  }

  .arrowBox {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }

  .arrow-down {
    display: flex;
    justify-content: center;
    position: relative;
    top: -5px;
    width: 0;
    height: 0;
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    border-top: 13px solid #f90;
    @media screen and (max-width: 599px) {
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid #f90;
    }
    transform: rotate(180deg);
  }

  .arrow-down.rain {
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #0b7ace;
  }

  p.boxParameter {
    margin-bottom: 0.5em;
  }

  span.bold {
    font-weight: 700;
  }

  .climateInfo {
    display: flex;
    align-items: baseline;
  }

  // icon
  div.iconIntro {
    display: flex;
    justify-content: center;
    @media screen and (max-width: 599px) {
      margin-bottom: 0.5em;
    }
  }

  // comment
  .comment {
    margin-top: 3em;
  }

  .boxStyleToday.rain {
    background-color: #0b7ace;
  }

  .divider {
    width: 35%;
    margin: 10px 0;
    border-bottom: 1px solid #f2c0ba;
    @media screen and (max-width: 599px) {
      width: 25%;
      margin: 5px 0;
    }
  }
  .c2060 .divider {
    border-bottom: 1px solid #fbd1cd;
  }
  .c2085 .divider {
    border-bottom: 1px solid #fbc1d3;
  }
  .c2060.rain .divider {
    border-bottom: 1px solid #a7dbdb;
  }
  .c2085.rain .divider {
    border-bottom: 1px solid #ded9bf;
  }
`

export default Indicator
